import { AvailableBusiness } from './clients/features'

export const environment: {
  env: 'development' | 'preproduction' | 'production'
  segmentKey: string
  checkoutKey: string
  nodeEnv: string
  baseUrl: string
  apiKey: string
  currentAppVersion: string
  client: AvailableBusiness
} = {
  env: import.meta.env.REACT_APP_ENV,
  segmentKey: import.meta.env.REACT_APP_SEGMENT_KEY,
  checkoutKey: import.meta.env.REACT_APP_CHECKOUT,
  nodeEnv: import.meta.env.NODE_ENV,
  baseUrl: import.meta.env.REACT_APP_BASE_URL,
  apiKey: import.meta.env.REACT_APP_API_KEY,
  currentAppVersion: import.meta.env.REACT_APP_VERSION,
  client: import.meta.env.REACT_APP_CLIENT,
}
